/** Reads a repeated numeric URL search param into a deduped number[]. */
export const readIdsFromUrl = (key: string): number[] => {
	const params = new URLSearchParams(globalThis.location.search);
	const values = params.getAll(key);
	const ids = values.map(Number).filter((n) => Number.isFinite(n) && n > 0);
	return [...new Set(ids)];
};
